import React from "react";
import styled from "styled-components";
import Tile from "../Tile";
import { DEFAULT_TILE_WIDTH, DEFAULT_TILE_HEIGHT } from "../Tile/Tile";

// Renders the stock slot's current face:
//   - card back when the stock has cards (clickable, draws next batch)
//   - "big-x" when stock is empty and recycling would just cycle the same
//     cards back through the same fan — a visible "dead end" signal; not
//     clickable.
//   - recycle icon when stock is empty but recycling would yield a
//     different fan than the current waste top (clickable).
//   - nothing when both stock and waste are empty.
//
// Every face renders inside the same fixed-size Slot so the stock cell's
// box never changes across states — swapping the face (or showing none)
// can't nudge the board row's layout.
function Stock({ count, canRecycle, deadEnd, cardBack, onClick }) {
  let face = null;
  if (count > 0)
    face = (
      <Tile
        name={cardBack}
        as="button"
        onClick={onClick}
        aria-label="Draw from the stock"
      />
    );
  else if (deadEnd) face = <Tile name="big-x" />;
  else if (canRecycle)
    face = (
      <Tile
        name="recycle"
        as="button"
        onClick={onClick}
        aria-label="Turn the waste over"
      />
    );
  return <Slot>{face}</Slot>;
}

const Slot = styled.div`
  width: ${DEFAULT_TILE_WIDTH}px;
  height: ${DEFAULT_TILE_HEIGHT}px;
`;

export default Stock;
